export const shouldUseNewLogin = (): boolean => {
  return true;
};
